




































import ClientForm from "@/views/clients/ClientForm.vue";
import ClientList from "@/views/clients/ClientList.vue";
// import EnroleesList from "@/views/enrolees/EnroleesList.vue";
import { useMainStore } from "@/store/storage";

import { defineComponent, reactive, toRefs } from "@vue/composition-api";

export default defineComponent({
  name: 'ClientPage',
  components: {
    ClientList,
    ClientForm,
    // EnroleesList
  },
  setup() {
    const main = useMainStore();
    const state = reactive({
      activeId: -1,
      showEnrolees: true
    });

    function showClientForm(status: boolean) {
      state.showEnrolees = status;
      main.state.clientId = ''
      main.resetClientData
    }

    // root.$on('clicked',( e: Client )=>{
    // })

    // // function triggerAction(e: Client) {
    //     alert('d')
    // }

    return {
      ...toRefs(state),
      mainStore: main,
      mainState: main.state,
      showClientForm
    };
  }
});
